import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class Beneficiaries extends RestApiModel {
  static get(userId, id) {
    return api.get(`/users/${userId}/beneficiaries/${id}`);
  }

  static create(userId, params) {
    return api.post(`/users/${userId}/beneficiaries`, params);
  }

  static update(userId, id, params) {
    return api.patch(`/users/${userId}/beneficiaries/${id}`, params);
  }

  static delete(userId, id) {
    return api.delete(`/users/${userId}/beneficiaries/${id}`);
  }

  static getResourceEndpoint(userId) {
    return `/users/${userId}/beneficiaries`;
  }

  /**
   * Get the single beneficiary for a user (1:1 relationship).
   * Returns the beneficiary or null if none exists.
   *
   * @param {string} userId
   * @returns {Promise<Object|null>}
   */
  static async getSingle(userId) {
    try {
      const response = await api.get(`/users/${userId}/beneficiaries`);
      return (response.data && response.data.data) ? response.data.data : null;
    } catch (error) {
      // If 404 or no data, return null (beneficiary doesn't exist)
      if ((error.response && error.response.status === 404) || !error.response) {
        return null;
      }
      // Re-throw other errors
      throw error;
    }
  }
}

export default Beneficiaries;

